import { render, staticRenderFns } from "./CodeSandboxOmniView.vue?vue&type=template&id=f9edbfc0&scoped=true&"
import script from "./CodeSandboxOmniView.vue?vue&type=script&setup=true&lang=js&"
export * from "./CodeSandboxOmniView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CodeSandboxOmniView.vue?vue&type=style&index=0&id=f9edbfc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9edbfc0",
  null
  
)

export default component.exports